import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.model.canLoadMore}}
  {{hide-application-footer}}
{{/if}}

{{#if this.noContent}}
  <EmptyState
    @title={{this.model.emptyState.title}}
    @body={{this.model.emptyState.body}}
  />
{{else}}
  <LoadMore
    @selector=".paginated-topics-list .topic-list .topic-list-item"
    @action={{action "loadMore"}}
    class="paginated-topics-list"
  >
    <TopicDismissButtons
      @position="top"
      @selectedTopics={{this.bulkSelectHelper.selected}}
      @model={{this.model}}
      @showResetNew={{this.showResetNew}}
      @showDismissRead={{this.showDismissRead}}
      @resetNew={{action "resetNew"}}
      @dismissRead={{if
        this.showDismissRead
        (route-action "dismissReadTopics")
      }}
    />

    {{#if (or this.model.loadingBefore this.incomingCount)}}
      <div class="show-mores">
        <a
          tabindex="0"
          href
          {{on "click" this.showInserted}}
          class="alert alert-info clickable
            {{if this.model.loadingBefore 'loading'}}"
        >
          <CountI18n
            @key="topic_count_latest"
            @count={{or this.model.loadingBefore this.incomingCount}}
          />
          {{#if @model.loadingBefore}}
            {{loading-spinner size="small"}}
          {{/if}}
        </a>
      </div>
    {{/if}}

    <BasicTopicList
      @topicList={{this.model}}
      @hideCategory={{this.hideCategory}}
      @showPosters={{this.showPosters}}
      @tagsForUser={{this.tagsForUser}}
      @canBulkSelect={{this.canBulkSelect}}
      @bulkSelectHelper={{this.bulkSelectHelper}}
      @changeSort={{this.changeSort}}
      @order={{this.order}}
      @ascending={{this.ascending}}
      @focusLastVisitedTopic={{true}}
    />

    <TopicDismissButtons
      @position="bottom"
      @selectedTopics={{this.bulkSelectHelper.selected}}
      @model={{this.model}}
      @showResetNew={{this.showResetNew}}
      @showDismissRead={{this.showDismissRead}}
      @resetNew={{action "resetNew"}}
      @dismissRead={{if
        this.showDismissRead
        (route-action "dismissReadTopics")
      }}
    />

    <ConditionalLoadingSpinner @condition={{this.model.loadingMore}} />
  </LoadMore>
{{/if}}
*/
{
  "id": "6qY4n0R1",
  "block": "[[[41,[30,0,[\"model\",\"canLoadMore\"]],[[[1,\"  \"],[1,[34,1]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"noContent\"]],[[[1,\"  \"],[8,[39,2],null,[[\"@title\",\"@body\"],[[30,0,[\"model\",\"emptyState\",\"title\"]],[30,0,[\"model\",\"emptyState\",\"body\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,3],[[24,0,\"paginated-topics-list\"]],[[\"@selector\",\"@action\"],[\".paginated-topics-list .topic-list .topic-list-item\",[28,[37,4],[[30,0],\"loadMore\"],null]]],[[\"default\"],[[[[1,\"\\n    \"],[8,[39,5],null,[[\"@position\",\"@selectedTopics\",\"@model\",\"@showResetNew\",\"@showDismissRead\",\"@resetNew\",\"@dismissRead\"],[\"top\",[30,0,[\"bulkSelectHelper\",\"selected\"]],[30,0,[\"model\"]],[30,0,[\"showResetNew\"]],[30,0,[\"showDismissRead\"]],[28,[37,4],[[30,0],\"resetNew\"],null],[52,[30,0,[\"showDismissRead\"]],[28,[37,6],[\"dismissReadTopics\"],null]]]],null],[1,\"\\n\\n\"],[41,[28,[37,7],[[30,0,[\"model\",\"loadingBefore\"]],[30,0,[\"incomingCount\"]]],null],[[[1,\"      \"],[10,0],[14,0,\"show-mores\"],[12],[1,\"\\n        \"],[11,3],[24,\"tabindex\",\"0\"],[24,6,\"\"],[16,0,[29,[\"alert alert-info clickable\\n            \",[52,[30,0,[\"model\",\"loadingBefore\"]],\"loading\"]]]],[4,[38,8],[\"click\",[30,0,[\"showInserted\"]]],null],[12],[1,\"\\n          \"],[8,[39,9],null,[[\"@key\",\"@count\"],[\"topic_count_latest\",[28,[37,7],[[30,0,[\"model\",\"loadingBefore\"]],[30,0,[\"incomingCount\"]]],null]]],null],[1,\"\\n\"],[41,[30,1,[\"loadingBefore\"]],[[[1,\"            \"],[1,[28,[35,10],null,[[\"size\"],[\"small\"]]]],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[8,[39,11],null,[[\"@topicList\",\"@hideCategory\",\"@showPosters\",\"@tagsForUser\",\"@canBulkSelect\",\"@bulkSelectHelper\",\"@changeSort\",\"@order\",\"@ascending\",\"@focusLastVisitedTopic\"],[[30,0,[\"model\"]],[30,0,[\"hideCategory\"]],[30,0,[\"showPosters\"]],[30,0,[\"tagsForUser\"]],[30,0,[\"canBulkSelect\"]],[30,0,[\"bulkSelectHelper\"]],[30,0,[\"changeSort\"]],[30,0,[\"order\"]],[30,0,[\"ascending\"]],true]],null],[1,\"\\n\\n    \"],[8,[39,5],null,[[\"@position\",\"@selectedTopics\",\"@model\",\"@showResetNew\",\"@showDismissRead\",\"@resetNew\",\"@dismissRead\"],[\"bottom\",[30,0,[\"bulkSelectHelper\",\"selected\"]],[30,0,[\"model\"]],[30,0,[\"showResetNew\"]],[30,0,[\"showDismissRead\"]],[28,[37,4],[[30,0],\"resetNew\"],null],[52,[30,0,[\"showDismissRead\"]],[28,[37,6],[\"dismissReadTopics\"],null]]]],null],[1,\"\\n\\n    \"],[8,[39,12],null,[[\"@condition\"],[[30,0,[\"model\",\"loadingMore\"]]]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]]]],[\"@model\"],false,[\"if\",\"hide-application-footer\",\"empty-state\",\"load-more\",\"action\",\"topic-dismiss-buttons\",\"route-action\",\"or\",\"on\",\"count-i18n\",\"loading-spinner\",\"basic-topic-list\",\"conditional-loading-spinner\"]]",
  "moduleName": "discourse/templates/user-topics-list.hbs",
  "isStrictMode": false
});